var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBikeSharing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_34959",
    "data-name": "Group 34959",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40.032,
    viewBox: "0 0 40 40.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6358",
    "data-name": "Rectangle 6358",
    width: 40,
    height: 40.032,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34958",
    "data-name": "Group 34958",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24451",
    "data-name": "Path 24451",
    d: "M9.923,198.821c.253-.586.514-1.152.734-1.733a.6.6,0,0,0-.113-.441c-.663-1.043-1.342-2.075-2.01-3.115a.888.888,0,0,1-.183-.406c-.017-.8-.008-1.606-.008-2.435H14.8V193.8h-2.37L18.3,202.85c.1-.156.188-.277.266-.4q1.976-3.137,3.95-6.274a7.142,7.142,0,0,1,6.39-3.545h1.364a9.946,9.946,0,0,0-.178-1.737A1.374,1.374,0,0,0,28.7,189.9c-.512-.017-1.026,0-1.571,0,0-1.043,0-2.061,0-3.08,2.95-.4,5.323.722,6.087,3.574a4.759,4.759,0,0,1,.126,1.2c.012,2.237.006,4.474.006,6.712v.481A8.214,8.214,0,0,1,39,202.948a7.985,7.985,0,0,1,.835,5.527A8.214,8.214,0,1,1,30.2,198.76v-3.053a19.909,19.909,0,0,0-2.306.145,3.9,3.9,0,0,0-2.672,1.892c-1.49,2.376-2.993,4.744-4.478,7.122a7.193,7.193,0,0,1-4.177,3.242c-.254.074-.3.22-.355.432a8.052,8.052,0,0,1-6.758,6.41,8.2,8.2,0,1,1,.469-16.129m20.306,3.241a5.038,5.038,0,0,0-3.453,5.636,5.078,5.078,0,0,0,10.075-1.185c-.083-2-1.964-4.379-3.5-4.4q0,2.29,0,4.579a1.565,1.565,0,1,1-3.117.027c-.007-1.305,0-2.61,0-3.915v-.738m-21.611-.208c-2.153-.576-4.864,1.443-5.411,3.988a5.1,5.1,0,0,0,4.277,6.044c2.361.369,5.256-1.462,5.465-3.474q-2.273,0-4.543,0a1.58,1.58,0,0,1-1.563-2.394c.43-1.008.865-2.013,1.3-3.021.162-.378.318-.758.478-1.142m7.388,3.2-3.222-4.966-2.233,5.214c1.834-.11,3.6.175,5.455-.248",
    transform: "translate(0 -175.042)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24452",
    "data-name": "Path 24452",
    d: "M219.861,17.111c-2.475-2.26-4.787-4.66-6.078-7.826A6.646,6.646,0,1,1,226.525,6.88a9.078,9.078,0,0,1-1.642,4.565,26.6,26.6,0,0,1-4.894,5.6.719.719,0,0,1-.127.07m0-4.353A16.653,16.653,0,0,0,222.993,8.4a5.9,5.9,0,0,0,.3-.82,3.526,3.526,0,1,0-6.673.394,15.682,15.682,0,0,0,3.245,4.783",
    transform: "translate(-199.901 0)",
    fill: "#353841"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeSharing);
export default __webpack_public_path__ + "static/media/bikeSharing.1859d8be9da63a0b20fa4bf32a3696b0.svg";
export { ForwardRef as ReactComponent };